module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000",
      "font-size": "18px",
      "padding": "20px 0"
    }
  }, [_vm._v(_vm._s(_vm.sysparam.homesectitle3 ?
    _vm.sysparam.homesectitle3.sysparambeg : ''))]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.cuList), function(cu) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.link(cu.cuaddr)
        }
      }
    }, [(cu.culogo) ? _c('img', {
      attrs: {
        "src": _vm.picAddr + cu.culogo.replace('/upload/', '')
      }
    }) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0ce7c803!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/Sy.vue
// module id = 293
// module chunks = 0